<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block v-bind="attrs" v-on="on">
        <v-icon>create_new_folder</v-icon> Add CoreCoach
      </v-btn>
    </template>
    <v-card flat>
      <template v-if="!show_lookup && !show_form">
        <v-card-title>
          We have options for you
        </v-card-title>
        <v-card-subtitle>
          How would you like to add a CoreCoach?
        </v-card-subtitle>
        <v-card-text>
          <v-card outlined @click="show_lookup = true" class="mb-4">
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="auto" class="my-auto">
                  <v-icon size="50" color="primary">search</v-icon>
                </v-col>
                <v-col>
                  <v-card-title>
                    Assign existing member
                  </v-card-title>
                  <v-card-subtitle>
                    Find a member and give them the CoreCoach role
                  </v-card-subtitle>
                </v-col>
                <v-spacer class="limited-spacer"></v-spacer>
                <v-col cols="auto" class="my-auto">
                  <v-icon size="40" color="secondarytext">
                    keyboard_arrow_right
                  </v-icon>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card outlined @click="show_form = true">
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="auto" class="my-auto">
                  <v-icon size="50" color="primary">person_add</v-icon>
                </v-col>
                <v-col>
                  <v-card-title>
                    Add CoreCoach Member
                  </v-card-title>
                  <v-card-subtitle>
                    Add new member and give them the role of CoreCoach
                  </v-card-subtitle>
                </v-col>
                <v-spacer class="limited-spacer"></v-spacer>
                <v-col cols="auto" class="my-auto">
                  <v-icon size="40" color="secondarytext">
                    keyboard_arrow_right
                  </v-icon>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
      </template>
      <template v-else-if="show_lookup">
        <v-card-title>
          Lookup Existing Member
        </v-card-title>
        <v-card-subtitle>
          Find an existing member to give the CoreCounts role
        </v-card-subtitle>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <member-autocomplete
              v-model="user"
              :multiple="false"
              label="Find Member"
            ></member-autocomplete>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="saving" @click="save">
            Update
          </v-btn>
        </v-card-actions>
      </template>
      <template v-else-if="show_form">
        <member-detail-form
          show-core-coach
          v-on:save="formSave"
        ></member-detail-form>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import MemberDetailForm from "@/components/members/MemberDetailForm";
import MemberAutocomplete from "@/components/members/MemberAutocomplete";
export default {
  name: "AddCoreCoachDialog",
  components: { MemberDetailForm, MemberAutocomplete },
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    importFile: null,
    show_lookup: false,
    show_form: false,
    userId: null
  }),
  watch: {
    dialog(val, oldVal) {
      if (val != oldVal && !val) {
        this.show_lookup = false;
        this.show_form = false;

        this.$store.dispatch("user/clearUser");
        this.userId = null;
      }
    }
  },
  computed: {
    user: {
      get() {
        return [this.userId];
      },
      set(val) {
        this.userId = (val || [""])[0];
      }
    }
  },
  created() {
    this.$store.dispatch("user/clearUser");
    this.userId = null;
  },
  methods: {
    formSave() {
      this.$emit("save");
      this.dialog = false;
    },
    save() {
      if (this.userId && this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("corecoaches/assignCoreCoach", this.userId)
          .then(() => {
            this.$emit("save");
            this.$refs.form.reset();
            this.$root.$snackbarSuccess("Member updated");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while assigning a CoreCoach role."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
